module.exports = __webpack_public_path__ + "img/argentina.4ea32397.svg";